module.exports = __webpack_public_path__ + "dist/solution_1.2ccd9eee.png";